import React, { useState, useEffect,useMemo,useCallback } from "react";
import { ToastContainer } from "react-toastify";
import Select from "react-select";
import { Button, Modal } from "react-bootstrap";
import PageTitle from "../../../layouts/PageTitle";
import Table from "../../../components/table/ReactTable/Table";
import useFullPageLoader from "../../../../hooks/useFullPageLoader";
import { ColumnFilter } from "../../../components/table/ReactTable/ColumnFilter";
import { Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import validator from "validator"; //https://www.npmjs.com/package/validator
import { warehouseActions, masterActions } from "../../../../_store";
import { useSelector, useDispatch } from "react-redux";
import Toastr from "../../../components/common/Toastr";
import swal from "sweetalert";
import generatePDF from "../../../components/export/generatePDF";
import generateXlsx from "../../../components/export/generateXlsx";
import { fCurrency, fNumber } from "../../../../utils/formatNumber";
import CommonService from "../../../../services/Common/CommonService";

const Warehouse = () => {
  const dispatch = useDispatch();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const currentUser = useSelector((x) => x.auth.user);
  const warehouse = useSelector((x) => x.warehouse.warehouse);
  const warehouseList = useSelector((x) => x.warehouse.warehouseList);
  const warehouseResponse = useSelector((x) => x.warehouse.warehouseResponse);
  const stateDrpList = useSelector((x) => x.master.stateDrpList);
  const deleteWarehouseResponse = useSelector(
    (x) => x.warehouse.deleteWarehouseResponse
  );
  const isLoading = useSelector((x) => x.warehouse.isLoading);
  const [stateList, setStateList] = useState([]);

  //Add State
  const [addFormData, setAddFormData] = useState({
    WareHouseID: 0,
    TotalInventory: "",
    Address: "",
    TotalCapacity: "",
    City: "",
    AvailableSpace: "",
    StateID: "",
    OutofStockItems: "",
    ZipCode: "",
    WarehouseOperator: "",
    TotalAisles: "",
    WareHouseNumber: "",
    StateOption: null,
    IsZipCode: true,
    Status: 1,
    CreatedBy: currentUser.Id,
  });

    const [finalTableData, setFinalTableData] = useState([]);

    const handleTableDataUpdate = useCallback((data) => {
      setFinalTableData(data);
    }, []);

  const newFormData = { ...addFormData };

  let styles = {
    control: (styles) => ({ ...styles, border: "1px solid red" }),
  };

  const COLUMNS = [
    {
      Header: "Warehouse No",
      Footer: "Warehouse No",
      accessor: "WareHouseNumber",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Total Inventory",
      Footer: "Total Inventory",
      accessor: "TotalInventoryStr",
      fieldType:"commaSeparator",
      //  Cell: ({ value }) => { return fNumber(value) },
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Total Capacity",
      Footer: "Total Capacity",
      accessor: "TotalCapacityStr",
      fieldType:"commaSeparator",
      justify: "center",
      // Cell: ({ value }) => { return fNumber(value) },
      Filter: ColumnFilter,
    },
    {
      Header: "Out of Stock Items",
      Footer: "Out of Stock Items",
      accessor: "OutofStockItemsStr",
      fieldType:"commaSeparator",
      justify: "center",
      // Cell: ({ value }) => { return fNumber(value) },
      Filter: ColumnFilter,
    },
    {
      Header: "Warehouse Operator",
      Footer: "Warehouse Operator",
      accessor: "WarehouseOperator",
      justify: "left",
      Filter: ColumnFilter,
    },

    {
      Header: "Total Aisles",
      Footer: "Total Aisles",
      accessor: "TotalAislesStr",
      justify: "center",
      fieldType:"commaSeparator",
      // Cell: ({ value }) => { return fNumber(value) },
      Filter: ColumnFilter,
    },

    {
      Header: "Status",
      Footer: "Status",
      accessor: "StatusName",
      Cell: ({ value }) => {
        return (
          <>
            <Badge variant="primary light badge-lg"> {value}</Badge>
          </>
        );
      },
      Filter: ColumnFilter,
    },
    {
      Header: "",
      Footer: "",
      accessor: "WareHouseID",
      disableFilters: true,
      Cell: ({ value }) => {
        return (
          <>
            <div className="d-flex">
              <Link
                onClick={() => handleEditClick(value)}
                className="btn btn-primary shadow btn-xs sharp me-1"
                title="Edit"
              >
                <i className="fas fa-pen"></i>
              </Link>
              <Link
                onClick={() => handleDeleteClick(value)}
                className="btn btn-danger shadow btn-xs sharp"
                title="Delete"
              >
                <i className="fa fa-trash"></i>
              </Link>
            </div>
          </>
        );
      },
    },
  ];

  const columns = useMemo(() => COLUMNS, []);

  const generateColumns = [
    {
      header: "Warehouse No",
      dataKey: "WareHouseNumber",
    },
    {
      header: "Total Inventory",
      dataKey: "TotalInventoryStr",
    },
    {
      header: "Total Capacity",
      dataKey: "TotalCapacity",
    },
    {
      header: "Out of Stock Items",
      dataKey: "OutofStockItemsStr",
    },
    {
      header: "Warehouse Operator",
      dataKey: "WarehouseOperator",
    },
    {
      header: "Total Aisles",
      dataKey: "TotalAislesStr",
    },
    {
      header: "Status",
      dataKey: "StatusName",
    },
  ];

  useEffect(() => {
    showLoader();
    dispatch(masterActions.GetStateList());
    dispatch(warehouseActions.getWarehouseDetails());
  }, [dispatch]);

  useEffect(() => {
    let CountryUSAId = 233;
    let stateList = [...stateDrpList];
    stateList = stateList.filter((d) => d.parentId === CountryUSAId);
    setStateList(stateList);
  }, [stateDrpList]);

  useEffect(() => {
    if (isLoading) {
      hideLoader();
    }
  }, [isLoading]);

  const [isOpenModal, setOpenModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  // handle Change function
  const handleChange = (event) => {
    event.preventDefault();
    const regexString = /^[a-zA-Z\s]*$/;
    const regexNumber = /^[0-9\b]+$/;
    const nospecial = /^[a-zA-Z0-9]+$/;
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    if (fieldValue && fieldValue.trim()) {
      //if (fieldName === "WareHouseNumber" || fieldName === "TotalInventory" || fieldName === "TotalCapacity" || fieldName === "OutofStockItems" || fieldName === "AvailableSpace" || fieldName === "TotalAisles") {
      if (
        fieldName === "TotalInventory" ||
        fieldName === "TotalCapacity" ||
        fieldName === "OutofStockItems" ||
        fieldName === "AvailableSpace" ||
        fieldName === "TotalAisles"
      ) {
        if (fieldValue === "" || regexNumber.test(fieldValue)) {
          newFormData[fieldName] = fieldValue;
        }
      } else if (fieldName === "WareHouseNumber") {
        if (fieldValue === "" || regexNumber.test(fieldValue)) {
          if (fieldValue !== "0") {
            newFormData[fieldName] = fieldValue;
          }
        }
      } else if (fieldName === "WarehouseOperator" || fieldName === "City") {
        if (fieldValue === "" || regexString.test(fieldValue)) {
          newFormData[fieldName] = fieldValue;
        }
      } else if (fieldName === "ZipCode") {
        if (fieldValue === "" || regexNumber.test(fieldValue)) {
          newFormData[fieldName] = fieldValue;
        }
      } else {
        newFormData[fieldName] = fieldValue;
      }
    } else {
      newFormData[fieldName] = fieldValue.trim();
    }
    // if (fieldName === "ZipCode" && fieldValue) {
    //     newFormData.IsZipCode = validator.isPostalCode(fieldValue.toString(), 'US')
    // }

    setAddFormData(newFormData);
  };

  // handle Dropdown Change function
  const handleDrpChange = (event, title) => {
    // const newFormData = { ...addFormData };
    newFormData[title] = event.value && parseInt(event.value);
    if (title === "StateID") {
      newFormData.StateOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    }
    setAddFormData(newFormData);
  };

  // handle Check Box Click function
  // const handleCkBoxChange = (event, title) => {
  //     newFormData[title] = event.target.checked === true ? 1 : 2;
  //     setAddFormData(newFormData);
  // };

  // handle Check Box Click function
  const handleCkBoxChange = (event, title) => {
    let hasChecked = event.target.checked === true ? 1 : 2;
    if (
      !event.target.checked &&
      newFormData.WareHouseID &&
      newFormData.WareHouseID > 0
    ) {
      showLoader();

      let Param = { DeleteID: newFormData.WareHouseID, DeleteType: 6 };
      CommonService.CheckMappedItem(Param).then((res) => {
        if (res.data === 1) {
          newFormData[title] = hasChecked;
          setAddFormData(newFormData);
          hideLoader();
        } else {
          Toastr("This Warehouse is already mapped", "warning");
          hideLoader();
        }
      });
    } else {
      newFormData[title] = hasChecked;
      setAddFormData(newFormData);
    }
  };

  const handlePoupClick = () => {
    newFormData.WareHouseID = 0;
    newFormData.Status = 1;
    newFormData.TotalInventory =
      newFormData.Address =
      newFormData.TotalCapacity =
      newFormData.City =
      newFormData.AvailableSpace =
      newFormData.OutofStockItems =
      newFormData.StateID =
      newFormData.ZipCode =
      newFormData.WarehouseOperator =
      newFormData.TotalAisles =
      newFormData.WareHouseNumber =
        "";
    newFormData.StateOption = null;
    newFormData.IsZipCode = true;
    setAddFormData(newFormData);
    setOpenModal(true);
    setSubmitted(false);
  };

  const handleEditClick = (Id) => {
    hideLoader();
    dispatch(warehouseActions.getWarehouseById({ WareHouseID: Id }));
    setOpenModal(true);
    setSubmitted(false);
  };

  const handleDeleteClick = (Id) => {
    swal({
      title: "Are you sure, you want to delete this Warehouse?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoader();
        let Param = { DeleteID: Id, DeleteType: 6 };
        CommonService.CheckMappedItem(Param).then((res) => {
          if (res.data === 1) {
            // Core API
            dispatch(
              warehouseActions.deleteWarehouse({
                WarehouseID: Id,
                DeletedBy: currentUser.Id,
              })
            );
            hideLoader();
          } else {
            Toastr("This Warehouse is already mapped", "warning");
            hideLoader();
          }
        });
      }
    });
  };

  // Submit data function
  const handleSubmit = (event) => {
    event.preventDefault();
    showLoader();
    var error = false;
    if (
      !addFormData.TotalInventory ||
      addFormData.TotalInventory <= 0 ||
      !addFormData.Address ||
      !addFormData.TotalCapacity ||
      addFormData.TotalCapacity <= 0 ||
      !addFormData.City ||
      !addFormData.AvailableSpace ||
      addFormData.AvailableSpace <= 0 ||
      !addFormData.StateID ||
      addFormData.StateID === 0 ||
      !addFormData.OutofStockItems ||
      addFormData.OutofStockItems <= 0 ||
      !addFormData.ZipCode ||
      !addFormData.WarehouseOperator ||
      !addFormData.TotalAisles ||
      addFormData.TotalAisles <= 0 ||
      !addFormData.WareHouseNumber
    ) {
      error = true;
      Toastr("Please fill in the required missing fields", "warning");
    } else if (
      newFormData.ZipCode.length > 5 ||
      newFormData.ZipCode.length < 3
    ) {
      Toastr("Please fill in the Data in Valid Form", "warning");
      error = true;
    }

    if (!error) {
      dispatch(warehouseActions.saveWarehouse(newFormData));
    } else {
      hideLoader();
      setSubmitted(true);
    }
  };

  // Warehouse Add And Update
  useEffect(() => {
    if (warehouseResponse === 1) {
      hideLoader();
      Toastr("Warehouse saved successfully", "success");
      dispatch(
        warehouseActions.getWarehouseDetails({ CurrentUserID: currentUser.Id })
      );
      newFormData.WareHouseID = newFormData.StateID = 0;
      newFormData.TotalInventory =
        newFormData.Address =
        newFormData.TotalCapacity =
        addFormData.City =
        addFormData.AvailableSpace =
        newFormData.OutofStockItems =
        newFormData.ZipCode =
        newFormData.WarehouseOperator =
        newFormData.TotalAisles =
        newFormData.WareHouseNumber =
          "";
      setOpenModal(false);
      setAddFormData(newFormData);
    } else if (warehouseResponse === 2) {
      hideLoader();
      Toastr("Warehouse updated successfully", "success");
      dispatch(
        warehouseActions.getWarehouseDetails({ CurrentUserID: currentUser.Id })
      );
      newFormData.WareHouseID = newFormData.StateID = 0;
      newFormData.TotalInventory =
        newFormData.Address =
        newFormData.TotalCapacity =
        addFormData.City =
        addFormData.AvailableSpace =
        newFormData.OutofStockItems =
        newFormData.ZipCode =
        newFormData.WarehouseOperator =
        newFormData.TotalAisles =
        newFormData.WareHouseNumber =
          "";
      setOpenModal(false);
      setAddFormData(newFormData);
    } else if (warehouseResponse === -1) {
      hideLoader();
      Toastr("Warehouse Number already exists ", "warning");
    }
  }, [warehouseResponse]);

  // handleDeleteClick
  useEffect(() => {
    if (deleteWarehouseResponse === 1) {
      hideLoader();
      Toastr("Warehouse deleted successfully", "success");
      dispatch(warehouseActions.getWarehouseDetails());
    } else if (deleteWarehouseResponse === -1) {
      hideLoader();
      Toastr("Error ", "warning");
    }
  }, [deleteWarehouseResponse]);

  //Edit Warehouse
  useEffect(() => {
    if (warehouse && warehouse.WareHouseID > 0) {
      hideLoader();
      newFormData.WareHouseID = warehouse.WareHouseID;
      newFormData.TotalInventory = warehouse.TotalInventory;
      newFormData.TotalCapacity = warehouse.TotalCapacity;
      newFormData.AvailableSpace = warehouse.AvailableSpace;
      newFormData.OutofStockItems = warehouse.OutofStockItems;
      newFormData.TotalAisles = warehouse.TotalAisles;
      newFormData.Address = warehouse.Address;
      newFormData.City = warehouse.City;
      newFormData.WareHouseNumber = warehouse.WareHouseNumber;
      newFormData.WarehouseOperator = warehouse.WarehouseOperator;
      newFormData.ZipCode = warehouse.ZipCode;
      newFormData.StatusName = warehouse.StatusName;
      newFormData.Status = warehouse.Status;
      newFormData.StateID = warehouse.StateID;
      newFormData.StateOption = {
        value: warehouse.StateID,
        label: warehouse.StateName,
      };
      newFormData.IsZipCode = true;
      setAddFormData(newFormData);
    }
  }, [warehouse]);

  ///  export  //
  const handleClickPDF = () => {
    let title = "Warehouse List";
    const columnStyles = {
      WareHouseNumber: { halign: "center", cellWidth: 40 },
      TotalInventoryStr: { halign: "center", cellWidth: 40 },
      TotalCapacity: { halign: "center", cellWidth: 40 },
      OutofStockItemsStr: { halign: "center", cellWidth: 40 },
      WarehouseOperator: { halign: "left", cellWidth: 30 },
      TotalAislesStr: { halign: "center", cellWidth: 25 },
      StatusName: { halign: "center", cellWidth: 30 },
    };
   
      generatePDF(finalTableData, generateColumns, true, title, columnStyles
    );
  };

  const handleClickExcel = () => {
    let title = "Warehouse";
    let generateExcelColumns = [
      "Warehouse No",
      "Total Inventory",
      "Total Capacity",
      "Out of Stock Items",
      "Warehouse Operator",
      "Total Aisles",
      "Status",
    ];
    let new_WarehouseList =
      finalTableData &&
      finalTableData.map(function (obj) {
        return {
          WareHouseNumber: obj.WareHouseNumber,
          TotalInventory: obj.TotalInventoryStr,
          TotalCapacity: obj.TotalCapacityStr,
          OutofStockItems: obj.OutofStockItemsStr,
          WarehouseOperator: obj.WarehouseOperator,
          TotalAisles: obj.TotalAislesStr,
          StatusName: obj.StatusName,
        };
      });

    generateXlsx(new_WarehouseList, generateExcelColumns, title);
  };

  const handleClosePopup = () => {
    dispatch(warehouseActions.clearWarehouseResponse());
    setOpenModal(false);
  };

  return (
    <>
      <PageTitle activeMenu="Warehouse" motherMenu="Master" />
      <ToastContainer />
      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">Warehouse List</h4>
          <div className="float-sm-end">
            {warehouseList && warehouseList.length > 0 && (
              <>
                <Button
                  className="me-2"
                  variant="danger btn-rounded"
                  onClick={handleClickPDF}
                >
                  <span className="btn-icon-start text-danger">
                    <i className="fa fa-solid fa-file-pdf"></i>
                    {/* <i className="fa fa-regular fa-file-excel"></i> */}
                  </span>
                  PDF
                </Button>
                <Button
                  className="me-2"
                  variant="secondary btn-rounded"
                  onClick={handleClickExcel}
                >
                  <span className="btn-icon-start text-secondary">
                    {/* <i className="fa fa-solid fa-file-pdf"></i> */}
                    <i className="fa fa-regular fa-file-excel"></i>
                  </span>
                  Excel
                </Button>
              </>
            )}
            <Button
              variant="primary btn-rounded"
              className="me-2"
              onClick={handlePoupClick}
            >
              <span className="btn-icon-start text-primary">
                <i className="fa fa-plus color-info" />
              </span>
              Add
            </Button>
          </div>
        </div>
        <div className="card-body">
          <Table columns={columns} data={warehouseList} onDataUpdate={handleTableDataUpdate} />
        </div>
      </div>
      {/* <!-- Modal --> */}

      <Modal className="fade bd-example-modal-lg" show={isOpenModal} size="lg">
        <Modal.Header>
          <Modal.Title>
            {newFormData.WareHouseID > 0 ? "Edit Warehouse" : "Add Warehouse"}
          </Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => handleClosePopup()}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">
                  Warehouse Number<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    submitted && !newFormData.WareHouseNumber && "border-danger"
                  }`}
                  autocomplete="off"
                  name="WareHouseNumber"
                  required="required"
                  onChange={handleChange}
                  value={newFormData.WareHouseNumber}
                  placeholder="Warehouse Number"
                  minLength={1}
                  maxLength={1}
                />
                <span className="validation-text"></span>
              </div>
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">
                  Total Inventory <span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control ${
                      submitted &&
                      (!newFormData.TotalInventory ||
                        newFormData.TotalInventory <= 0) &&
                      "border-danger"
                    }`}
                    autocomplete="off"
                    name="TotalInventory"
                    required="required"
                    onChange={handleChange}
                    value={newFormData.TotalInventory}
                    placeholder="Total Inventory"
                    minLength={1}
                    maxLength={7}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">
                  Total Capacity<span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control ${
                      submitted &&
                      (!newFormData.TotalCapacity ||
                        newFormData.TotalCapacity <= 0) &&
                      "border-danger"
                    }`}
                    autocomplete="off"
                    name="TotalCapacity"
                    required="required"
                    onChange={handleChange}
                    value={newFormData.TotalCapacity}
                    placeholder="Total Capacity"
                    minLength={1}
                    maxLength={7}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">
                  Available Space<span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control ${
                      submitted &&
                      (!newFormData.AvailableSpace ||
                        newFormData.AvailableSpace <= 0) &&
                      "border-danger"
                    }`}
                    autocomplete="off"
                    name="AvailableSpace"
                    required="required"
                    onChange={handleChange}
                    value={newFormData.AvailableSpace}
                    placeholder="Available Space"
                    minLength={1}
                    maxLength={7}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">
                  Out of Stock Items<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    submitted &&
                    (!newFormData.OutofStockItems ||
                      newFormData.OutofStockItems <= 0) &&
                    "border-danger"
                  }`}
                  autocomplete="off"
                  name="OutofStockItems"
                  required="required"
                  onChange={handleChange}
                  value={newFormData.OutofStockItems}
                  placeholder="Out of Stock Items"
                  min={1}
                  maxLength={7}
                />
                <span className="validation-text"></span>
              </div>
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">
                  {" "}
                  Warehouse Operator<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    submitted &&
                    !newFormData.WarehouseOperator &&
                    "border-danger"
                  }`}
                  autocomplete="off"
                  name="WarehouseOperator"
                  required="required"
                  onChange={handleChange}
                  value={newFormData.WarehouseOperator}
                  placeholder="Warehouse Operator"
                  min={1}
                  maxLength={50}
                />
                <span className="validation-text"></span>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">
                  Total Aisles<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    submitted &&
                    (!newFormData.TotalAisles ||
                      newFormData.TotalAisles <= 0) &&
                    "border-danger"
                  }`}
                  autocomplete="off"
                  name="TotalAisles"
                  required="required"
                  onChange={handleChange}
                  value={newFormData.TotalAisles}
                  placeholder="Total Aisles"
                  min={1}
                  maxLength={7}
                />
                <span className="validation-text"></span>
              </div>
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">
                  Address <span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control ${
                      submitted && !newFormData.Address && "border-danger"
                    }`}
                    autocomplete="off"
                    name="Address"
                    required="required"
                    onChange={handleChange}
                    value={newFormData.Address}
                    placeholder="Address"
                    maxLength={300}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">
                  City<span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control ${
                      submitted && !newFormData.City && "border-danger"
                    }`}
                    autocomplete="off"
                    name="City"
                    required="required"
                    onChange={handleChange}
                    value={newFormData.City}
                    placeholder="City"
                    maxLength={50}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>
              <div className="col-md-6 mb-4">
                <div className="contact-name">
                  <label className="text-black font-w500">
                    State<span className="text-danger">*</span>
                  </label>
                  <Select
                    classNamePrefix={"custom_select_css"}
                    name="StateID"
                    //defaultValue={Usertype}
                    value={newFormData.StateOption}
                    onChange={(event) => handleDrpChange(event, "StateID")}
                    options={stateList}
                    styles={
                      submitted &&
                      (!newFormData.StateID || newFormData.StateID === 0)
                        ? styles
                        : ""
                    }
                  />
                  <span className="validation-text"></span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">
                  {" "}
                  Zip Code<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    submitted &&
                    (!newFormData.ZipCode ||
                      newFormData.ZipCode.length > 5 ||
                      newFormData.ZipCode.length < 3) &&
                    "border-danger"
                  }`}
                  autocomplete="off"
                  name="ZipCode"
                  required="required"
                  onChange={handleChange}
                  value={newFormData.ZipCode}
                  placeholder="Zip Code"
                  min={1}
                  maxLength={5}
                />
                <span className="validation-text text-danger">
                  {!newFormData.IsZipCode && "Please enter valid Zip Code"}
                </span>
              </div>

              <div className="col-md-6 mb-5">
                <label className="text-black font-w500">Active</label>
                <div>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="Status"
                      role="switch"
                      id="flexSwitchCheckDefault"
                      checked={newFormData.Status === 1 ? true : false}
                      onChange={(event) => handleCkBoxChange(event, "Status")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="danger light"
            // onClick={() => setOpenModal(false)}
            onClick={() => handleClosePopup()}
          >
            Close
          </Button>
          <Button
            variant=""
            // onClick={() => setLargeModal(false)}
            onClick={handleSubmit}
            className="btn btn-primary"
          >
            {newFormData.WareHouseID > 0 ? "Update" : "Add"}
          </Button>
        </Modal.Footer>
      </Modal>

      {loader}
    </>
  );
};

export default Warehouse;
